import { useState } from 'react';
import { Link } from 'react-router-dom';
import { brand } from '../../data/content';
import './Navbar.css';

const navLinks = [
  { to: '/#solucoes', label: 'Soluções' },
  { to: '/#automacao-n8n', label: 'N8N e IA' },
  { to: '/casos', label: 'Casos' },
  { to: '/blog', label: 'Blog' },
  { to: '/sobre', label: 'Sobre' },
  { to: '/contato', label: 'Contato' },
  { to: '/portal', label: 'Portal do Cliente' },
];

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="container navbar-inner">
        <Link to="/" className="navbar-logo" onClick={() => setMenuOpen(false)}>
          <span className="logo-name">{brand.name}</span>
          <span className="logo-tagline">{brand.tagline}</span>
        </Link>

        <nav className={`navbar-nav ${menuOpen ? 'open' : ''}`}>
          {navLinks.map((link) => (
            <Link key={link.label} to={link.to} onClick={() => setMenuOpen(false)}>
              {link.label}
            </Link>
          ))}
        </nav>

        <Link to="/diagnostico" className="btn btn-primary navbar-cta" onClick={() => setMenuOpen(false)}>
          Solicitar Diagnóstico
        </Link>

        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
}

export default Navbar;
